export const MAX_CACHE_AGE = 2073600; // 4 weeks
